module.exports = __webpack_public_path__ + "img/score-1.784d9d9a.png";